import { Gamepad2, Users, Trophy, Zap, type LucideIcon } from "lucide-react";
import terminatorUprisingImage from "@/assets/terminator-uprising.jpg";
import cookdUpImage from "@/assets/cookd-up.jpg";
import deadAheadImage from "@/assets/dead-ahead.jpg";
import arrowsongImage from "@/assets/arrowsong.jpg";
import cyberShockImage from "@/assets/cyber-shock.jpg";
import wizardAcademyImage from "@/assets/wizard-academy.jpg";
import wayfindersImage from "@/assets/wayfinders.jpg";
import trialsImage from "@/assets/trials-of-atlantis-poster.jpg.asset.json";
import versusImage from "@/assets/versus.jpg.asset.json";
import darkOmenImage from "@/assets/arrowsong-dark-omen.jpg.asset.json";
import copsImage from "@/assets/cops-vs-robbers-poster.jpg.asset.json";

export type GameFeature = { icon: LucideIcon; text: string };
export type Game = {
  slug: string;
  title: string;
  genres: string[];
  description: string;
  image: string;
  features: GameFeature[];
};

export const genres = ["All Games", "Action", "Adventure", "Casual"];

export const games: Game[] = [
  {
    slug: "trials-of-atlantis",
    title: "Trials of Atlantis",
    genres: ["Adventure"],
    description: "Herstel Atlantis in vijf unieke uitdagingen vol puzzels en actie. Werk samen, ontdek de schatkamer en trotseer een reusachtige octopus!",
    image: trialsImage.url,
    features: [
      { icon: Users, text: "1-6 Players" },
      { icon: Gamepad2, text: "Free-Roam" },
      { icon: Trophy, text: "Puzzle Adventure" },
    ],
  },
  {
    slug: "versus",
    title: "Versus",
    genres: ["Action"],
    description: "Daag elkaar uit in retrofuturistische VR-lasergame-arena's. Strijd in teams of ieder voor zich, met blasters en schilden!",
    image: versusImage.url,
    features: [
      { icon: Users, text: "2-8 Players" },
      { icon: Gamepad2, text: "Free-Roam" },
      { icon: Trophy, text: "PvP Laser Tag" },
    ],
  },
  {
    slug: "arrowsong-dark-omen",
    title: "Arrowsong Dark Omen",
    genres: ["Adventure", "Action"],
    description: "Pak je boog en trek samen door vervloekte landen. Stop de cultus en bescherm het rijk tegen de krachten van de Dark Lord!",
    image: darkOmenImage.url,
    features: [
      { icon: Users, text: "1-6 Players" },
      { icon: Gamepad2, text: "Free-Roam" },
      { icon: Trophy, text: "Co-op Fantasy Archery" },
    ],
  },
  {
    slug: "cops-vs-robbers",
    title: "Cops VS Robbers",
    genres: ["Action"],
    description: "Politie tegen overvallers in een spannende PvP-shooter. Zoek dekking, gebruik de omgeving en verras het andere team!",
    image: copsImage.url,
    features: [
      { icon: Users, text: "1-6 Players" },
      { icon: Gamepad2, text: "Free-Roam" },
      { icon: Zap, text: "PvP Action" },
    ],
  },
  {
    slug: "terminator-uprising",
    title: "Terminator Uprising",
    genres: ["Action"],
    description: "Sluit je aan bij het verzet tegen Skynet in deze intense VR shooter. Vecht tegen Terminators in een post-apocalyptisch slagveld!",
    image: terminatorUprisingImage,
    features: [
      { icon: Users, text: "2-6 Players" },
      { icon: Gamepad2, text: "Free-Roam" },
      { icon: Zap, text: "Sci-Fi Action" },
    ],
  },
  {
    slug: "cookd-up",
    title: "Cook'd Up",
    genres: ["Casual", "Action"],
    description: "Chaotisch, hilarisch en vol teamwork! Kook, bak en serveer in deze gekke VR keuken ervaring voor het hele gezin.",
    image: cookdUpImage,
    features: [
      { icon: Users, text: "2-6 Players" },
      { icon: Gamepad2, text: "Free-Roam" },
      { icon: Trophy, text: "Family Friendly" },
    ],
  },
  {
    slug: "dead-ahead",
    title: "Dead Ahead",
    genres: ["Action"],
    description: "Jij en je team zijn omsingeld door zombies in de straten van de stad. Pak je wapens en overleef de horde!",
    image: deadAheadImage,
    features: [
      { icon: Users, text: "2-6 Players" },
      { icon: Gamepad2, text: "Free-Roam" },
      { icon: Zap, text: "Zombie Shooter" },
    ],
  },
  {
    slug: "arrowsong",
    title: "Arrowsong",
    genres: ["Adventure"],
    description: "Orcs, goblins en een dreigende draak willen de heilige boom vernietigen! Pak je boog en breng vrede in het feeënrijk.",
    image: arrowsongImage,
    features: [
      { icon: Users, text: "2-6 Players" },
      { icon: Gamepad2, text: "Free-Roam" },
      { icon: Trophy, text: "Fantasy Archery" },
    ],
  },
  {
    slug: "cyber-shock",
    title: "Cyber Shock",
    genres: ["Action"],
    description: "Een snelle, futuristische VR shooter. Storm door neon-verlichte cyberpunk arena's en blast je een weg door golven aan vijanden!",
    image: cyberShockImage,
    features: [
      { icon: Users, text: "2-6 Players" },
      { icon: Gamepad2, text: "Free-Roam" },
      { icon: Zap, text: "Futuristic Shooter" },
    ],
  },
  {
    slug: "wizard-academy",
    title: "Wizard Academy",
    genres: ["Adventure"],
    description: "Word leerling van de magische academie! Werp spreuken, los puzzels op en beleef een betoverend co-op fantasy avontuur.",
    image: wizardAcademyImage,
    features: [
      { icon: Users, text: "2-6 Players" },
      { icon: Gamepad2, text: "Free-Roam" },
      { icon: Trophy, text: "Magical Adventure" },
    ],
  },
  {
    slug: "wayfinders",
    title: "Wayfinders",
    genres: ["Adventure"],
    description: "Ontdek mysterieuze landschappen en los uitdagende puzzels op in dit betoverend co-op avontuur. Een meeslepende reis vol wonderen en ontdekkingen!",
    image: wayfindersImage,
    features: [
      { icon: Users, text: "2-6 Players" },
      { icon: Gamepad2, text: "Free-Roam" },
      { icon: Trophy, text: "Puzzle Adventure" },
    ],
  },
];
